import { EmptyUnreadPropsFactory, IUnreadProps } from '@/entities/Unread'

export interface INotificationState {
  unread: IUnreadProps
}

export const state = (props?: Partial<INotificationState>): INotificationState => ({
  unread: EmptyUnreadPropsFactory(),
  ...props
})

export default state
